<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="adc">
<a id="page02">
<h2 class="adCardHead"><span class="bold">Books by Janet Dean</span></h2>
<p class="adCardsubhead">Love Inspired Historical</p>
<p class="adCardText"><em class="italic">Courting Miss Adelaide</em></p>
<p class="adCardText"><em class="italic">Courting the Doctor’s Daughter</em></p>
<p class="adCardText"><em class="italic">The Substitute Bride</em></p>
</a></div>
<a id="page02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// substitutebridethe_adc.vue?c34121c2